import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { TextArea } from '@dealstack/frontend/shared/components/forms/TextArea/TextArea';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { em, rem } from '@mantine/core';
import ReactModal from 'react-modal';
import styled from 'styled-components';

export const HeaderText = styled(Text)`
	color: ${({ theme }) => theme.v2.color.neutral[700]};
`;

export const TopWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 1em;
`;

export const MessageWrapper = styled.div`
	background-color: ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: ${em(8)};
	margin-bottom: ${em(16)};
`;

export const StyledTextarea = styled(TextArea)`
	width: 100%;
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	color: ${defaultTheme.v2.color.neutral[600]};

	textarea {
		font-size: ${rem(14)};
		line-height: ${rem(20)};
		border: none;
		&:focus {
			border: none;
		}
		caret-color: ${defaultTheme.v2.color.neutral[600]};
		color: ${defaultTheme.v2.color.neutral[600]};
		background-color: ${({ theme }) => theme.v2.color.neutral[100]};
	}
`;

export const BottomWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
`;

export const ButtonGroup = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
`;

export const NotificationCheckboxWrapper = styled.div`
	label {
		color: ${({ theme }) => theme.v3.colors.dark[9]};
	}
`;

export const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 36rem;
	background-color: ${({ theme }) => theme.v2.color.white[500]};
	border-radius: ${em(8)};
`;

export const StyledModal = styled(ReactModal)`
	display: flex;
	flex-direction: column;
	width: 36rem;
	background-color: ${({ theme }) => theme.v2.color.white[500]};
	border-radius: ${em(8)};
`;
